import { ArrowUpRight } from "lucide-react";

const CTA = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="cta-section"
      className="relative bg-black text-white py-24 lg:py-32 overflow-hidden grain"
    >
      <div className="blob bg-[#C7343D] w-[500px] h-[500px] top-[-150px] left-[-100px] opacity-30" />
      <div className="blob bg-[#F3901A] w-[450px] h-[450px] bottom-[-150px] right-[-100px] opacity-25" />

      <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-4 mb-8">
              <div className="h-px w-12 bg-[#F3901A]" />
              <span className="text-xs font-semibold tracking-[0.3em] uppercase text-[#F3901A]">
                ¡Hagamos Equipo!
              </span>
            </div>
            <h2
              data-testid="cta-heading"
              className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-light tracking-[-0.03em] leading-[1] text-white text-balance"
            >
              ¿Listo para impulsar tu
              <span className="italic font-extralight text-[#F3901A]"> negocio </span>
              con la red de distribución más{" "}
              <span className="text-[#C7343D]">confiable</span> de Jalisco?
            </h2>
            <p className="mt-8 text-white/70 text-lg leading-relaxed font-light max-w-2xl">
              Conversemos sobre cómo podemos colocar tus productos en los puntos
              de venta correctos o abastecer tu negocio con esquemas flexibles
              de consignación.
            </p>
          </div>

          <div className="lg:col-span-4 flex lg:justify-end">
            <button
              onClick={() => scrollTo("contacto")}
              data-testid="cta-button"
              className="btn-primary relative z-10 bg-[#C7343D] border border-[#C7343D] text-white px-10 py-6 text-xs font-semibold tracking-[0.25em] uppercase inline-flex items-center gap-4 hover:border-[#F3901A] w-full lg:w-auto justify-center"
            >
              Contáctanos
              <ArrowUpRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
